import {Component, input} from '@angular/core';
import {DeviceAssociation} from "src/app/infrastructure/moovement-api/models/asset";

@Component({
  selector: 'app-asset-metadata',
  standalone: true,
  imports: [],
  templateUrl: './asset-metadata.component.html',
  styleUrl: './asset-metadata.component.css'
})
export class AssetMetadataComponent {

  id = input.required<string | undefined>();
  relatedDeviceAssociations = input.required<DeviceAssociation[]>();
}
